import { NgClass } from '@angular/common';
import { Component, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ListViewItem } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-ui-list-view-items',
  imports: [FlexLayoutModule, MatIconModule, TranslatePipe, NgClass, MatListModule],
  templateUrl: './list-view-items.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-view-items.component.scss'
})
export class ListViewItemsComponent {
  items = input.required<ListViewItem[]>();
  selectedItem = model<ListViewItem>();
  selectionChange = output<ListViewItem>();

  onSelectItem(data: ListViewItem): void {
    this.selectedItem.set(data);
    this.selectionChange.emit(data);
  }
}
